module.exports = __webpack_public_path__ + "files/d3b40d6812634fae88e4934219334d9a.png";